import Settings from "../pages/settings/Settings";

function SettingsRoutes() {
    return [{ path: '/settings', element: <Settings /> }];
}

export default SettingsRoutes;
